<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择件号"
    style="width: 100%"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.part_number"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { commodityList } from '../../service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
    departmentLimit: false,
    status: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else {
        this.requestDefaultItem()
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.val > 0) {
      this.requestDefaultItem()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    async requestDefaultItem() {
      let res = await commodityList({ default_id: this.val, page: 0, size: 20 })
      this.lists = res.data.list
      this.selected = this.val
    },
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          part_number: query,
          department_limit: this.departmentLimit,
          status: this.status,
          page: 0,
          size: 20,
        }
        let res = await commodityList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>